import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

/**
 * OTA (atualização "pelo ar") do app nativo via @capgo/capacitor-updater em
 * modo self-hosted — o updateUrl (em capacitor.config.ts) aponta pro nosso
 * endpoint `POST /api/v1/app/ota/check` na bow-backend-vm, que devolve o bundle
 * web novo quando há. Assim, mudanças "só web" chegam aos apps instalados sem
 * passar pela revisão da loja. O plugin checa/baixa/aplica sozinho (autoUpdate).
 *
 * No-op no PWA/web: lá a atualização vem pelo Service Worker (ver main.tsx).
 */

/**
 * Sinaliza ao updater que este bundle bootou e está executando OK.
 *
 * ⚠️ CRÍTICO: sem este sinal, o plugin considera a versão "quebrada" e faz
 * **rollback automático** pro bundle anterior após o `appReadyTimeout`. É a
 * rede de segurança do OTA — um bundle que não inicia volta sozinho. Por isso
 * chamamos o mais cedo possível no boot (antes de qualquer `await` de rede), pra
 * uma conexão lenta NÃO disparar rollback falso de um bundle que está saudável.
 */
export async function notifyOtaReady(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await CapacitorUpdater.notifyAppReady();
  } catch {
    // Plugin indisponível (ex.: build sem o updater) — não bloqueia o boot.
  }
}
